<template>
  <div class="home">
      <Navigation />
      <EventList />
      <EventAttendanceDisplay />
  </div>
</template>

<script>
import Navigation from "@/components/Navigation";
import EventList from "@/components/organisms/EventList"
import EventAttendanceDisplay from "@/components/attendance/EventAttendanceDisplay";

export default {
  name: "Attendance",
  components: {
    Navigation,
    EventList,
    EventAttendanceDisplay,
  },
  beforeMount() {
    const sessionCheck = sessionStorage.getItem("userSignedIn");
    if (this.$store.state.signedInUser === false) {      
      if (sessionCheck !== "true") {
        let data = decodeURIComponent(this.$route.query.data);
        data = encodeURIComponent(data);
        this.$router.push(`/signin?data=${data}`);
      }
    }
  },
};
</script>

<style lang="scss" scoped src="@/styles/style-home.scss">
</style>
